<template>
    <div class="condition-content">
        <compare-value
            ref="compare"
            input-placeholder="请输入文本型值"
            input-unit=""
            selector-type="LOGIC"
            :valid="valid"
            :value="currentValue"
            @change="onChange"
        />
    </div>
</template>

<script>
import CompareValue from './template/compare-value';

export default {
  name: 'Remarks',

  components: {
    CompareValue,
  },

  props: {
    optionInfo: {
      type: Object,
      default() {
        return {};
      },
    },
    value: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    let currentValue = this.value || {};
    if (!currentValue.value) {
      currentValue = {
        operand: '==',
        value: null,
      };
    }
    return {
      currentValue,
      valid: true,
    };
  },
  computed: {
    brief() {
      const { operand, value } = this.currentValue;
      const selectText =                this.$refs.compare
                && this.$refs.compare.$refs.selector.currentOptions.find(obj => operand === obj.value).text;
      return `${this.optionInfo.text}${selectText}${value}`;
    },
  },
  watch: {
    value(newValue) {
      this.currentValue = newValue;
    },
  },
  mounted() {
    this.onChange(this.currentValue);
  },
  methods: {
    validate() {
      this.valid = !!this.currentValue.value;
      return this.valid;
    },
    onChange(value) {
      this.valid = true;
      this.currentValue = value;
      const ruleData = {
        name: 'remarks',
        type: 'string',
        operation: this.getStringOperation(value.operand),
        value: value.value,
      };
      const showVal = value;
      this.$emit('change', {
        ruleData,
        showVal,
        brief: this.brief,
        validation: !!value.value,
      });
    },
    getStringOperation(operation) {
      return operation.replace('arrayInclude', 'contains');
    },
  },
};
</script>
